import axios from 'axios';

export const getIncidentReportData = async (
	scheduleAssignmentID,
	checklistID,
) => {
	try {
		const response = await axios({
			method: 'GET',
			url: `/api/activityreportcontroller/GetIncidentReportData?scheduleAssignmentID=${scheduleAssignmentID}&checklistID=${checklistID}`,
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		});
		return response?.data || -1;
	} catch (error) {
		console.log('ERROR GET CONTACT DATA :>> ', error);
		return -1;
	}
};
